module.exports = __webpack_public_path__ + "static/fonts/PorscheNextWCy-Bold.7ba1b596.woff";